// CharacterRotation.tsx
import { useEffect } from "react";
import useProgress from "../hooks/use-rotation-progress";

interface Props {
  className?: string;
  title?: string;
  defaultX?: number;
  defaultY?: number;
}

declare const mp: { trigger: (event: string, ...args: any[]) => void };

const CharacterRotation = ({
  className = "",
  title = "Rotatint Character",
  defaultX = 50,
  defaultY = 0,
}: Props) => {
  const [ref, percent] = useProgress({ x: defaultX, y: defaultY });
  const degrees = Math.round((percent.x / 100) * 360);

  useEffect(() => {
    try {
      mp.trigger("setClothingHeading", (percent.x / 100) * 360);
    } catch (e) {
      console.error("[CharacterRotation] mp.trigger failed:", e);
    }
  }, [percent.x]);

  return (
    <div
      className={`w-full select-none space-y-4 rounded-xl gilroy-font ${className}`}
    >
      {/* Zoom hint row */}
      {/** <div className="flex items-center gap-3">
        <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-white/10">
     
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="text-white/70"
          >
            <rect x="5" y="2" width="14" height="20" rx="7" />
            <line x1="12" y1="6" x2="12" y2="10" />
          </svg>
        </div>
        <div className="flex flex-col">
          <span className="text-sm font-semibold text-white">
            Zoom in / zoom out
          </span>
          <span className="text-xs text-white/40">Thats about camera here</span>
        </div>
      </div> */}

      {/* Rotation row */}
      <div className="space-y-2.5">
        <div className="flex items-center justify-between">
          <span className="text-[1rem] font-[500] text-white">{title}</span>
          <span className="text-[1rem] text-white/80 font-[500]">
            {degrees}
            <span className="text-white/40">/360</span>
          </span>
        </div>

        {/* Custom slider track */}
        <div className="rounded-[22px] px-3 py-1 bg-gradient-to-r from-[#1e2e37] to-[#1a1a25]">
          <div
            ref={ref}
            className="group relative flex h-5 w-full cursor-grab items-center active:cursor-grabbing"
          >
            {/* Track background */}
            <div className="relative h-1.5 w-full overflow-hidden rounded-full bg-white/10">
              {/* Filled / gradient portion */}
              <div
                className="absolute left-0 top-0 h-full rounded-full"
                style={{
                  width: `${percent.x}%`,
                  background:
                    "linear-gradient(90deg, #0e9f9f 0%, #2dd4bf 100%)",
                  boxShadow: "0 0 8px rgba(45, 212, 191, 0.5)",
                }}
              />
            </div>

            {/* Thumb */}
            <div
              className="pointer-events-none absolute top-1/2 h-4 w-4 -translate-y-1/2 rounded-full border-2 border-white bg-white shadow-lg transition-transform duration-75 group-active:scale-110"
              style={{ left: `calc(${percent.x}% - 8px)` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CharacterRotation;
